import { render } from "./ImprestAccountantList.vue?vue&type=template&id=548db41c"
import script from "./ImprestAccountantList.vue?vue&type=script&lang=js"
export * from "./ImprestAccountantList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__